// Firebase Configuration
// Get your config from: https://console.firebase.google.com
// Project Settings > General > Your apps > Web app > SDK setup and configuration

import { initializeApp } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js';
import { getAuth, connectAuthEmulator } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js';
import { getFirestore, connectFirestoreEmulator } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js';

// TODO: Replace with your Firebase project config
const firebaseConfig = {

  apiKey: "AIzaSyAyzmsm17nni57zNKwAWAHL-eg9phTcgm4",

  authDomain: "idlemile.firebaseapp.com",

  projectId: "idlemile",

  storageBucket: "idlemile.firebasestorage.app",

  messagingSenderId: "266188299038",

  appId: "1:266188299038:web:7ac7bbcb6f979cddb3c70f",

  measurementId: "G-Q042MLVZ32"

};


// Check if config is set up
const isConfigured = firebaseConfig.apiKey !== "YOUR_API_KEY";

// Initialize Firebase
let app = null;
let auth = null;
let db = null;

if (isConfigured) {
    try {
        app = initializeApp(firebaseConfig);
        auth = getAuth(app);
        db = getFirestore(app);

        // Use emulators in development (uncomment if using Firebase emulators)
        // if (location.hostname === 'localhost') {
        //     connectAuthEmulator(auth, 'http://localhost:9099');
        //     connectFirestoreEmulator(db, 'localhost', 8080);
        // }

        console.log('[Firebase] Initialized successfully');
    } catch (error) {
        console.error('[Firebase] Initialization error:', error);
    }
} else {
    console.warn('[Firebase] Not configured - cloud features disabled');
}

export { app, auth, db, isConfigured };
